<template>
  <banner
    v-if="shouldShowBanner"
    color-scheme="primary"
    :banner-message="bannerMessage"
    :action-button-label="actionButtonMessage"
    has-action-button
    @click="routeToBilling"
  />
</template>

<script>
import Banner from 'dashboard/components/ui/Banner.vue';
import { mapGetters } from 'vuex';
import adminMixin from 'dashboard/mixins/isAdmin';
import accountMixin from 'dashboard/mixins/account';

// const EMPTY_SUBSCRIPTION_INFO = {
//   plan_name: 'Free Plan',
//   subscribed_quantity: 1,
// };

export default {
  components: { Banner },
  mixins: [adminMixin, accountMixin],
  data() {
    return {
      showBannerIndicator: false,
    };
  },
  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      currentUser: 'getCurrentUser',
    }),
    bannerMessage() {
      return this.$t('GENERAL_SETTINGS.BILLING.FREETRIAL');
    },
    actionButtonMessage() {
      return this.$t('GENERAL_SETTINGS.BILLING.UPGRADE_NOW') + '🚀';
    },
    shouldShowBanner() {
      if (this.currentUser.role === 'agent') return false;
      return this.isFreeUser();
    },
  },
  methods: {
    routeToBilling() {
      this.$router.push({
        name: 'billing_settings_index',
        params: { accountId: this.accountId },
      });
    },
    isFreeUser() {
      const subscriptionInfo = this.getSubscriptionInfo();

      if (subscriptionInfo === false) return false;

      const { plan_name, subscribed_quantity } = subscriptionInfo;

      if (plan_name === 'Free Plan' && subscribed_quantity === 1) {
        return true;
      }

      return false;
    },
    getSubscriptionInfo() {
      const account = this.getAccount(this.accountId);
      if (!account) return false;

      const { custom_attributes: subscription } = account;
      if (!subscription) return false;

      // this.subscription = subscription;
      // this.account = account;

      const { plan_name, subscribed_quantity } = subscription;

      return { plan_name, subscribed_quantity };
    },
  },
};
</script>
